export default __webpack_public_path__ + "static/media/attractions5.065d4747.avif";